import { Grid } from 'antd';
import { memo, useMemo } from 'react';
import { type WebPageDataFragment } from '../../../../api/fragments/WebPageData';
import { allowedExtensions } from '../../../../utilities/extensions';
import useTranslatedString from '../../../../utilities/useTranslatedString';
import {
    StyledBannerImage,
    WebPageImageContainer,
    WebpageTitle,
    WebpageSubTitle,
    BannerTextContainer,
    TitleContainer,
    Video,
} from './shared';

type HeaderImageProps = {
    webpage: WebPageDataFragment;
};

const WebpageBannerImage = ({ webpage }: HeaderImageProps) => {
    const translated = useTranslatedString();

    const screens = Grid.useBreakpoint();

    const bannerExtension = useMemo(() => {
        if (screens.lg) {
            if (webpage.bannerImage?.filename) {
                return webpage.bannerImage.filename.split('.').pop();
            }

            return null;
        }
        if (webpage.mobileBannerImage?.filename) {
            return webpage.mobileBannerImage.filename.split('.').pop();
        }

        if (webpage.bannerImage?.filename) {
            return webpage.bannerImage.filename.split('.').pop();
        }

        return null;
    }, [screens.lg, webpage.bannerImage?.filename, webpage.mobileBannerImage?.filename]);

    const bannerAsset: string = useMemo(() => {
        if (screens.lg) {
            return webpage.bannerImage?.url ?? null;
        }

        return webpage.mobileBannerImage?.url ?? webpage.bannerImage?.url ?? null;
    }, [screens.lg, webpage.bannerImage?.url, webpage.mobileBannerImage?.url]);

    return (
        <WebPageImageContainer>
            {allowedExtensions.video.includes(`.${bannerExtension}`) && (
                <Video autoPlay loop muted playsInline>
                    <source src={bannerAsset} type={`video/${bannerExtension}`} />
                </Video>
            )}
            {allowedExtensions.image.includes(`.${bannerExtension}`) && (
                <StyledBannerImage preview={false} src={bannerAsset} />
            )}
            <BannerTextContainer>
                <TitleContainer>
                    <WebpageTitle>{translated(webpage.bannerTitle)}</WebpageTitle>
                    <WebpageSubTitle>{translated(webpage.bannerSubTitle)}</WebpageSubTitle>
                </TitleContainer>
            </BannerTextContainer>
        </WebPageImageContainer>
    );
};

export default memo(WebpageBannerImage);
